import { css } from '@emotion/react';
import { theme } from 'global';

const tableCell = css`
  gap: 8px;
  padding: 16px;
  height: 56px;
  min-height: 50px;
  ${css.ellipsisOverflow}
`;

export const tableHead = css`
  > .MuiTableRow-root {
    & > .MuiTableCell-root {
      border-bottom: none;
      ${tableCell}
      background-color: #FAFAFA;
    }
  }
`;

export const tableBody = css`
  > .MuiTableRow-root {
    & > .MuiTableCell-root {
      border-bottom: none;
      ${tableCell}
    }
  }
`;

export const sortLabel = (isSortingColumn) => css`
  & .MuiTableSortLabel-icon {
    color: ${isSortingColumn
      ? theme.colors.primary.dark
      : theme.colors.neutral[300]} !important;
  }
`;
